module.exports = __webpack_public_path__ + "img/koulingmibao.6ccc6a91.png";